<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "TSZ";
    }
  }
};
</script>
